import styled, { css } from 'styled-components';

import { size } from '../../layout/helpers';
import { fadeIn, noTransform } from '../../layout/keyframes';
import { ButtonReset } from '../../layout/reset';

export const Wrapper = styled.div`
  position: fixed;
  top: ${size(1)};
  right: ${size(1)};
  z-index: ${(props) => props.theme.zindex.snackbar};
`;

type ItemProps = React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> & {
  $isSuccess?: boolean;
  $isDanger?: boolean;
  $isWarning?: boolean;
  $isInfo?: boolean;
  $transition?: boolean;
};

export const Item = styled.div.attrs(() => ({
  role: 'alert',
}))<ItemProps>`
  display: flex;
  align-items: flex-start;
  width: 400px;
  max-width: calc(100vw - ${size(2)});
  padding: ${size(2)};
  background-color: var(--c-bg-main);
  color: var(--c-text-main);
  border-radius: var(--border-radius);
  box-shadow: 0 4px 8px rgba(var(--c-overlay-rgb), 0.2);
  border-left: ${size(1)} solid var(--c-border-main);
  transform: translateY(${size(1)});
  animation:
    ${noTransform} 300ms ease forwards,
    ${fadeIn} 300ms ease;

    ${({ $transition }) =>
      $transition &&
      css`
      transition: border-color 300ms ease;
    `}

  & + & {
    margin-top: ${size(0.5)};
  }

  ${({ $isSuccess }) =>
    $isSuccess &&
    css`
      border-color: var(--c-semantic-success-500);
    `}

  ${({ $isDanger }) =>
    $isDanger &&
    css`
      border-color: var(--c-semantic-error-500);
    `}

  ${({ $isWarning }) =>
    $isWarning &&
    css`
      border-color: var(--c-semantic-warning-500);
    `}

  ${({ $isInfo }) =>
    $isInfo &&
    css`
      border-color: var(--c-semantic-info-500);
    `}
`;

export const Content = styled.div`
  flex: 1 1 auto;
  display: flex;
  align-items: center;
  gap: ${size(1)};
  font-size: ${(props) => props.theme.font.size.small};
`;

export const Action = styled.div`
  flex-shrink: 0;
  padding-left: ${size(2)};
`;

export const Close = styled(ButtonReset)`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  font-size: ${size(2.5)};
  transform-origin: 50% 50%;
  transition: transform 200ms ease;

  :before {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    width: ${size(4)};
    height: ${size(4)};
    transform: translate(-50%, -50%);
    background-color: var(--c-semantic-neutral-300);
    border-radius: 50%;
    opacity: 0;
    transition: opacity 200ms ease;
  }

  :hover {
    :before {
      opacity: 1;
    }
  }

  :active {
    transform: scale(0.95);
  }

  > * {
    position: relative;
    z-index: 1;
  }
`;
